import React, { useState, useRef } from 'react'
import { MdAdd, MdRemove } from 'react-icons/md'
import styled from 'styled-components'

const GenericCollapses = (props) => {
  const [open, setOpen] = useState(false)
  const bodyRef = useRef()

  const height = !open ? 0 : bodyRef.current?.scrollHeight || 0

  return (
    <OuterContainer open={open} fontSize={props.$fontSize}>
      <Header onClick={() => setOpen(!open)} open={open} color={props.colorObj?.text}>
        {props.header}
        {open ? <RemoveIcon /> : <AddIcon />}
      </Header>

      <Body open={open} ref={bodyRef} height={height}>
        <H1>{props.body}</H1>
      </Body>
    </OuterContainer>
  )
}

export default GenericCollapses

const OuterContainer = styled.div`
  position: relative;
  width: 100%;
  font-size: ${(props) => (props.fontSize ? props.fontSize : 'initial')};
  border-bottom: 1px solid var(--light-grey);
`

const Header = styled.div`
  position: relative;
  width: 100%;
  font-size: 16px;
  display: flex;
  padding: 20px 5px;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;

  border-bottom: ${(props) => (props.open ? 'none' : props.color ? `1px solid ${props.color}` : 'none')};
`

const Body = styled.div`
  position: relative;
  padding: 0 10px;
  width: 100%;
  white-space: pre-line;
  overflow: hidden;
  height: ${(props) => props.height + 'px'};
  transition: all ease-in-out 0.2s;
  z-index: 2;
`
const RemoveIcon = styled(MdRemove)`
  font-size: 16px;
`

const AddIcon = styled(MdAdd)`
  font-size: 16px;
`
const H1 = styled.h1`
  font-size: 14px;
  font-weight: 450;
  line-height: 1.5;
  white-space: pre-line;
  margin: 0;
  padding: 0 0 10px 0;
`
